const genders = [
  { text: 'Maschio', value: 'M' },
  { text: 'Femmina', value: 'F' }
]

export default genders
